var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        width: "900px",
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "disp-flex flex-wrap",
          staticStyle: { "align-items": "center" },
          attrs: { slot: "title" },
          slot: "title"
        },
        [
          _c("strong", { staticClass: "mr-10" }, [
            _vm.item
              ? _c("span", [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(
                        _vm.$translate.action_message_code(
                          _vm.item.message_code
                        )
                      ) +
                      "\n\t\t\t\t"
                  ),
                  _vm.item.action_by_reference &&
                  _vm.item.action_by_reference.primary_invoice_by_reference
                    ? _c("span", [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(
                              _vm.item.action_by_reference
                                .primary_invoice_by_reference.invoice_number
                            ) +
                            "\n\t\t\t\t"
                        )
                      ])
                    : _vm._e()
                ])
              : _c("span", [
                  _vm._v(_vm._s(_vm.$t("interchangeEventDetail.title")))
                ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-tag",
                { staticClass: "mr-5", attrs: { size: "mini", type: "info" } },
                [
                  _vm._v(
                    _vm._s(_vm.interchangeCount) +
                      " " +
                      _vm._s(
                        _vm.$tc(
                          "interchangeEventDetail.interchanges",
                          _vm.interchangeCount
                        )
                      )
                  )
                ]
              ),
              _vm._v(" "),
              _c("el-tag", { attrs: { size: "mini", type: "info" } }, [
                _vm._v(
                  _vm._s(_vm.eventCount) +
                    " " +
                    _vm._s(
                      _vm.$tc(
                        "interchangeEventDetail.eventsCount",
                        _vm.eventCount
                      )
                    )
                )
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.dialogVisible && !_vm.loading && _vm.actionInterchanges.length
        ? _c("interchange-event-detail", {
            attrs: {
              "action-interchanges": _vm.actionInterchanges,
              "initial-event-ref": _vm.initialEventRef
            }
          })
        : _vm.loading
        ? _c("div", [_vm._v(_vm._s(_vm.$t("loading")))])
        : _c("div", [_vm._v(_vm._s(_vm.$t("noData")))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }